/**
 * Client-side stage-1 frame thinning (D.3 spec section 5.3): cap the captured
 * frame list at 150 entries by picking uniformly-spaced indices, always keeping
 * the first and last frame. Transcript-aware scoring is server-side stage 2.
 */

const CLIENT_TARGET = 150;

export function pickClientThinnedIndices(count) {
  if (count <= CLIENT_TARGET) {
    return Array.from({ length: count }, (_, i) => i);
  }
  const out = [];
  for (let i = 0; i < CLIENT_TARGET; i++) {
    out.push(Math.round((i * (count - 1)) / (CLIENT_TARGET - 1)));
  }
  return out;
}
